import { createContext, useContext } from 'react';

export const { history, location } = window;

export const RouterContext = createContext({});

export const LocationContext = createContext({});

export const useRouter = () => {
	return useContext(RouterContext);
};

export const useUrl = ({ matched = false, isNoMatched = false } = {}) => {
	const {
		state: { url, legacy },
		setState,
	} = useRouter();
	
	const setUrl = (assign, allowReturnBackWhenRedirected = false, state = {}) => {
		history &&
			history[allowReturnBackWhenRedirected ? 'replaceState' : 'pushState'](
				state,
				null,
				`${legacy ? '/#' : ''}${assign}`
			);
		setState(prev => ({
			...prev, 
			url: assign, 
			prevUrl: prev.url, 
			matched: assign === prev.url ? prev.matched : matched, 
			isNoMatched: assign === prev.url ? prev.isNoMatched : isNoMatched, 
			initial: false 
		}));
	};
	return { url, setUrl };
};

export const useHistory = () => {
	const { url, setUrl } = useUrl();
	return {
		url,
		push: (to, state) => setUrl(to, false, state),
		replace: (to, state) => setUrl(to, true, state),
		back,
		forward,
		refresh,
		state: history.state
	};
};

export const useParams = () => {
	const { parameters } = useContext(LocationContext);
	return parameters;
};

export const useLocation = () => {
	const { url, path } = useContext(LocationContext);

	return {
		url,
		path,
		search: location.search,
		hash: location.hash,
		pathname: location.pathname
	};
};

const back = (index = -1) => history.go(Math.min(-1, index));

const forward = (index = 1) => history.go(Math.max(1, index));

const refresh = () => history.go(0);
